import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import type { MenuInfo } from 'rc-menu/lib/interface';
import { Session, GroupedSessionsProject, NodeCategory } from 'api/useChat';
import arrowAltCircleUp from '../../../assets/arrow-alt-circle-up.png';
import deleteItem from '../../../assets/deleteItem.png';
import penToSquare from '../../../assets/penToSquare.svg';
import { useChatState } from '../state/chatState';

interface MoreActionsProps {
  page: 'chat-bot' | 'side-navigation';
  session?: Session;
  project?: GroupedSessionsProject;
  sessionIndex?: number;
  projectIndex?: number;
  category: string;
  onNewConversation?: (project?: GroupedSessionsProject) => void;
  nodeCategory: NodeCategory;
}

const MoreActions: React.FC<MoreActionsProps> = ({
  page,
  session,
  project,
  sessionIndex,
  projectIndex,
  category,
  onNewConversation,
  nodeCategory
}) => {
  const { openRenameDialog, openRemoveDialog, handleNewConversation } = useChatState();

  const getDropdownItems = (): MenuProps => {
    const items: MenuProps['items'] = [];

    if (page === 'chat-bot') {
      items.push(
        {
          key: '1',
          icon: <img src={arrowAltCircleUp} alt="rename" className="w-3 h-3" />,
          label: <span className="whitespace-nowrap">Rename Project</span>,
          onClick: () => {
            openRenameDialog({
              isOpen: true,
              sessionId: '',
              title: project?.name || '',
              sessionIndex: -1,
              updatedAt: project?.updatedAt || '',
              category,
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        },
        {
          key: '2',
          icon: <img src={deleteItem} alt="delete" className="w-3 h-3" />,
          label: <span className="whitespace-nowrap">Delete Project</span>,
          danger: true,
          onClick: () => {
            openRemoveDialog({
              isOpen: true,
              sessionId: project?.id || '',
              sessionIndex: -1,
              updatedAt: project?.updatedAt || '',
              category,
              projectId: project?.id || '',
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        }
      );
    } else if (nodeCategory === NodeCategory.PROJECT) {
      items.push(
        {
          key: '1',
          icon: <img src={penToSquare} alt="new conversation" className="w-3 h-3" />,
          label: 'Start a new session',
          onClick: ({ domEvent }: MenuInfo) => {
            domEvent.stopPropagation();
            handleNewConversation(project);
          }
        },
        {
          key: '2',
          icon: <img src={arrowAltCircleUp} alt="rename" className="w-3 h-3" />,
          label: <span className="whitespace-nowrap">Rename Project</span>,
          onClick: () => {
            console.log('project', category);
            openRenameDialog({
              isOpen: true,
              sessionId: project?.id || '',
              title: project?.name || '',
              sessionIndex: -1,
              updatedAt: project?.updatedAt || '',
              category,
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        },
        {
          key: '3',
          icon: <img src={deleteItem} alt="delete" className="w-3 h-3" />,
          label: <span className="whitespace-nowrap">Delete Project</span>,
          danger: true,
          onClick: () => {
            openRemoveDialog({
              isOpen: true,
              sessionId: project?.id ?? '',
              sessionIndex: -1,
              updatedAt: project?.updatedAt || '',
              category,
              projectId: project?.id || '',
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        }
      );
    } else {
      items.push(
        {
          key: '1',
          icon: <img src={arrowAltCircleUp} alt="rename" className="w-3 h-3" />,
          label: 'Rename Session',
          onClick: ({ domEvent }: MenuInfo) => {
            domEvent.stopPropagation();
            openRenameDialog({
              isOpen: true,
              sessionId: session?.id || '',
              title: session?.title || '',
              sessionIndex: sessionIndex ?? 0,
              updatedAt: session?.updatedAt || '',
              category,
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        },
        {
          key: '2',
          icon: <img src={deleteItem} alt="delete" className="w-3 h-3" />,
          label: 'Delete Session',
          danger: true,
          onClick: ({ domEvent }: MenuInfo) => {
            domEvent.stopPropagation();
            openRemoveDialog({
              isOpen: true,
              sessionId: session?.id || '',
              sessionIndex: sessionIndex ?? 0,
              updatedAt: session?.updatedAt || '',
              category,
              projectId: project?.id || '',
              nodeCategory,
              projectIndex: projectIndex ?? 0
            });
          }
        }
      );
    }

    return { items };
  };

  return (
    <Dropdown menu={getDropdownItems()} trigger={['click']} placement="bottom">
      <MoreOutlined className="text-lg hover:bg-gray-100 p-1 rounded-full" onClick={(e) => e.stopPropagation()} />
    </Dropdown>
  );
};

export default MoreActions;
